import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';
import DashboardIcon from '@material-ui/icons/Dashboard';

export const operationsModule = createFrontendPlugin({
  pluginId: 'operations',
  extensions: [
    PageBlueprint.make({
      name: 'operations',
      params: {
        path: '/operations',
        title: 'Operação',
        icon: <DashboardIcon fontSize="inherit" />,
        loader: () => import('./OperationsPage').then(m => <m.OperationsPage />),
      },
    }),
  ],
});
